import empService from '../services/empService.js';
import postQueue from '../services/postQueue';

export default {
  state: {
    emps: null,
    activeEmps: null,
    isFetching: false,
    empFps: null,
    fps: [],
    // empFilter: { isExit: false }
  },
  getters: {
    fps(state) {
      return state.fps;
    },
    empIdToFpMap(state) {
      if (!state.fps.length) return null;
      return state.fps.reduce((acc, fp) => {
        if (!acc[fp.empId]) {
          acc[fp.empId] = {};
        }
        acc[fp.empId] = {
          ...acc[fp.empId],
          [fp.variant]: fp.data,
        };
        return acc;
      }, {});
    },
    emps(state) {
      return state.emps;
    },
    activeEmps(state) {
      return state.activeEmps;
    },
    empMap(state) {
      return state.emps.reduce((acc, emp) => {
        acc[emp._id] = emp;
        return acc;
      }, {});
    },
    empFilter(state) {
      return state.empFilter;
    },
    isFetching(state) {
      return state.isFetching;
    },
  },
  mutations: {
    setEmps(state, { emps }) {
      state.emps = emps;
    },
    setActiveEmps(state, { activeEmps }) {
      state.activeEmps = activeEmps;
    },
    setFps(state, { fps }) {
      state.fps = fps;
    },
    saveFp(state, { fp: { empId, data, variant } }) {
      const fp = state.fps.find(
        (fp) => fp.empId === empId && fp.variant === variant,
      );
      if (fp) {
        fp.data = data;
      } else {
        state.fps.push({ empId, variant, data });
      }
    },
    saveEmp(state, { savedEmp }) {
      const empIdx = state.emps.findIndex((emp) => emp._id === savedEmp._id);
      if (empIdx === -1) {
        state.emps.push(savedEmp);
      } else {
        state.emps = state.emps.map((emp) => {
          if (emp._id === savedEmp._id) return savedEmp;
          return emp;
        });
      }
    },
    removeEmp(state, { empId }) {
      state.emps = state.emps.filter((emp) => emp._id !== empId);
    },
    setIsFetching(state, { isFetching }) {
      state.isFetching = isFetching;
    },
  },
  actions: {
    async loadActiveEmps(context) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const activeEmps = await empService.getActiveEmps();
        context.commit({ type: 'setActiveEmps', activeEmps });
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async loadFpsByEmpId(context, { empId }) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const fps = await empService.getFpsByEmpId(empId);
        return fps;
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async loadFps(context) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const fps = await empService.queryFps();
        context.commit({ type: 'setFps', fps });
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async loadEmps(context, { showAll } = {}) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const emps = await empService.query({ showAll });
        context.commit({ type: 'setEmps', emps });
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async saveEmpFp(context, { empId, data, variant }) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        const savedFp = await empService.saveEmpFp(empId, data, variant);
        context.commit({
          type: 'saveFp',
          fp: savedFp,
        });
      } catch (err) {
        postQueue.addToQueue(
          { func: empService.saveEmpFp, params: [empId, data, variant] },
          {
            func: context.commit,
            params: [{ type: 'saveFp', fp: 'res' }],
          },
        );
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async saveEmp(context, action) {
      try {
        const savedEmp = await empService.save(action.editedItem);
        context.commit({ type: 'saveEmp', savedEmp });
      } catch (err) {
        postQueue.addToQueue(
          { func: empService.save, params: [action.editedItem] },
          {
            func: context.commit,
            params: [{ type: 'saveEmp', savedEmp: 'res' }],
          },
        );
      }
    },
    async deleteEmp(context, { empId }) {
      context.commit('user/toggleLoader', null, { root: true });
      try {
        context.commit({ type: 'removeEmp', empId });
        const res = await empService.remove(empId);
      } catch (err) {
        postQueue.addToQueue(empService.remove, [empId]);
      } finally {
        context.commit('user/toggleLoader', null, { root: true });
      }
    },
    async downloadEmpSheet(context) {
      context.commit({ type: 'setIsFetching', isFetching: true });
      try {
        const res = await empService.downloadEmpSheet();
        let fileName = res.headers['content-disposition'].split('=')[1];
        const type = res.headers['content-type'];
        var reader = new FileReader();
        var blob = new Blob([res.data], { type });
        reader.readAsDataURL(blob);
        reader.onloadend = function (e) {
          var a = document.createElement('a');
          a.href = reader.result;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
        };
      } catch (err) {}
      context.commit({ type: 'setIsFetching', isFetching: false });
    },
  },
};
